var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBanner)?_c('div',{staticClass:"maintenance-banner"},[_c('iwm-callout',{attrs:{"type":"warning","position":"inline","label":_vm.maintenanceTitle,"duration":"0"}},[_c('div',{staticClass:"maintenance-content"},[(_vm.maintenanceMessage)?_c('p',[_vm._v(" "+_vm._s(_vm.maintenanceMessage)+" ")]):_vm._e()])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }